import {useCommentsPanelViewMode, useSelectedCommentReplyThreadId} from '../../stores/layout-selectors'
import {isReviewCommentsViewMode} from './CommentsViewControls'

/**
 * Whether a single thread is being shown in detail rather than the list of comments.
 *
 * @param filteredThreadIds When provided, detail mode is only reported while the selected
 * thread still matches the active filter.
 */
export function useIsThreadDetailMode(filteredThreadIds?: Set<string>): boolean {
  const viewMode = useCommentsPanelViewMode()
  const selectedThreadId = useSelectedCommentReplyThreadId()

  if (!isReviewCommentsViewMode(viewMode) || !selectedThreadId) return false

  return filteredThreadIds === undefined || filteredThreadIds.has(selectedThreadId)
}
